import styles from "./ErrorState.module.css";

/**
 * Shared error state (PRD §42, Implementation Guide §28).
 *
 * Users see friendly copy only. Technical detail is passed via
 * `detail` and rendered ONLY in development so we never expose
 * raw Firebase/API errors in production.
 */
const ErrorState = ({
  title = "We couldn't get the game data.",
  message = "This is on us, not on you. Give it another try in a moment.",
  detail,
  onRetry,
  retryLabel = "Try Again",
  className = "",
}) => {
  const showDetail = detail && process.env.NODE_ENV !== "production";

  return (
    <div className={`${styles.ErrorState} ${className}`.trim()} role="alert">
      <span className={styles.icon} aria-hidden="true">
        <i className="fa-solid fa-triangle-exclamation" />
      </span>
      <p className={styles.title}>{title}</p>
      {message && <p className={styles.message}>{message}</p>}

      {onRetry && (
        <button type="button" className="btn btn-primary mt-2" onClick={onRetry}>
          {retryLabel}
        </button>
      )}

      {showDetail && (
        <details className={styles.detail}>
          <summary>Developer detail</summary>
          <pre>{String(detail)}</pre>
        </details>
      )}
    </div>
  );
};

export default ErrorState;
